<template>
 <!-- 车辆新建修改 -->
 <div>
     <!-- 新建修改 -->
    <el-dialog :title="title" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="dialogVisible" @close="closeDialog" width="1160px" center>
      <span>
         <el-form :inline="true" :model="addFrom" ref="addFrom" :rules="rules" class="demo-form-inline yanzheng jiaoyan" label-width="120px" size="mini">
        <!-- <el-form-item label="审批人">
          <el-input  placeholder="审批人"></el-input>
        </el-form-item> -->
        <div class="inpBox">
               <!-- <el-form-item label="车牌号:" prop="vhcNo">
                <el-input  placeholder="" @blur="CPHfn()" :class="{ 'disabled': !isAdd }"  :readonly="!isAdd" v-model.trim="addFrom.vhcNo" maxlength="20"></el-input>
              </el-form-item> -->
              <el-form-item label="车牌号:" prop="vhcNo" v-if="!isAdd">
                <el-input  placeholder="" @blur="CPHfn()" :readonly="read" :class="read?'disabled':''" v-model.trim="addFrom.vhcNo" maxlength="20"></el-input>
              </el-form-item>
              <el-form-item label="车牌号:" prop="vhcNo" v-else>
                <el-input  placeholder="" @blur="CPHfn()" :readonly="read" :class="read?'disabled':''" v-model.trim="addFrom.vhcNo" maxlength="20"></el-input>
              </el-form-item>
               <el-form-item label="车牌颜色:" class="is-required"  prop="noColour">
                <el-select placeholder="请选择" value-key="id" v-model="addFrom.noColour" :disabled="read" :class="read?'disabled':''">
                  <el-option
                    v-for="item in clys"
                    :key="item.id"
                    :label="item.colourName"
                    :value="item"
                     v-if="item.id"
                  ></el-option>
                </el-select>
             </el-form-item>
              <el-form-item label="车辆类型:" class="is-required"  prop="vhcType">
                <el-select placeholder="请选择" value-key="id" v-model="addFrom.vhcType" :disabled="read" :class="read?'disabled':''">
                  <el-option
                    v-for="item in vehicleT"
                    :key="item.id"
                    :label="item.name"
                    :value="item"
                     v-if="item.id"
                  ></el-option>
                </el-select>
             </el-form-item>
               <el-form-item label="能源类型:" class="is-required"  prop="energy">
                <el-select placeholder="请选择" value-key="id" v-model="addFrom.energy" :disabled="read" :class="read?'disabled':''">
                  <el-option
                    v-for="item in NYtype"
                    :key="item.id"
                    :label="item.energyName"
                    :value="item"
                    v-if="item.id"
                  ></el-option>
                </el-select>
             </el-form-item>
              <el-form-item label="车辆所属:" prop="vhcClassify">
                <el-select placeholder="请选择" v-model="addFrom.vhcClassify" @change="classifyChange" :disabled="read" :class="read?'disabled':''">
                  <el-option
                    v-for="item in vehicleSS"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
             </el-form-item>
              <el-form-item label="所属单位/个人:"  prop="vehicleTenant" v-if="addFrom.vhcClassify==1" key="1">
                <el-select placeholder="请选择"  filterable  allow-create  remote reserve-keyword  :remote-method="remoteMethod"
                default-first-option v-model="addFrom.vehicleTenant" value-key="tenantCode" :disabled="read" :class="read?'disabled':''">
                  <el-option
                    v-for="(item,index) in ssdw"
                    :key="index"
                    :label="item.tenantName"
                    :value="item"
                  ></el-option>
                </el-select>
             </el-form-item>
             <el-form-item label="所属单位/个人:" prop="vehicleTenantName" v-if="addFrom.vhcClassify==2" key="2" >
                <el-input  placeholder="" v-model="addFrom.vehicleTenantName"  maxlength="11" :readonly="read" :class="read?'disabled':''"></el-input>
              </el-form-item>
             <el-form-item label="使用性质:"  prop="purpose">
                <el-select placeholder="请选择" value-key="id"  filterable allow-create
                default-first-option v-model="addFrom.purpose" :disabled="read" :class="read?'disabled':''">
                  <el-option
                    v-for="item in clyt"
                   :key="item.id"
                    :label="item.name"
                    :value="item"
                     v-if="item.id"
                  ></el-option>
                </el-select>
             </el-form-item>
             <el-form-item label="排放标准:"  prop="standards" >
                <el-select placeholder="请选择" value-key="id"  v-model="addFrom.standards" :disabled="read" :class="read?'disabled':''">
                  <el-option
                    v-for="item in pfbz"
                    :key="item.id"
                    :label="item.name"
                    :value="item"
                     v-if="item.id"
                  ></el-option>
                </el-select>
             </el-form-item>
              <el-form-item label="行驶证号:" prop="drivingLicense">
                <el-input  placeholder=""  v-number-input.float="0" maxlength="18" v-model="addFrom.drivingLicense" :readonly="read" :class="read?'disabled':''"></el-input>
              </el-form-item>
              <el-form-item label="总质量(吨):" prop="vhcQuality">
                <el-input  placeholder="" v-model="addFrom.vhcQuality"  v-number-input.float="3" maxlength="11" :readonly="read" :class="read?'disabled':''"></el-input>
              </el-form-item>
              <el-form-item label="载重(吨):" prop="weight">
                <el-input  placeholder=""  v-model="addFrom.weight"  v-number-input.float="3" maxlength="11" :readonly="read" :class="read?'disabled':''"></el-input>
              </el-form-item>
              <!-- <el-form-item label="外廓尺寸(米):" prop="">
              <el-select placeholder="请选择" value-key="id" v-model="vhcL" :disabled="!isAdd">
                <el-option
                    v-for="item in vehicleL"
                    :key="item.id"
                    :label="item.name"
                    :value="item"
                  ></el-option>
                </el-select>
              </el-form-item> -->
               <el-form-item label="车辆识别代号:" prop="vhcVinNo">
                <el-input  placeholder=""  maxlength="18" v-model="addFrom.vhcVinNo" :readonly="read" :class="read?'disabled':''"></el-input>
              </el-form-item>
              <!-- <el-form-item label="车辆识别代号:" prop="vhcVinNo">
                <el-input  placeholder=""  maxlength="18" v-model="addFrom.vhcVinNo"></el-input>
              </el-form-item> -->
               <el-form-item label="发动机号:"  prop="vhcEngineNo">
                <el-input  placeholder=""  maxlength="17"  v-model="addFrom.vhcEngineNo" :readonly="read" :class="read?'disabled':''"></el-input>
              </el-form-item>
              <el-form-item label="道路运输证号:"  prop="transportNo">
                <el-input  placeholder=""  maxlength="17"  v-model="addFrom.transportNo" :readonly="read" :class="read?'disabled':''"></el-input>
              </el-form-item>
              <el-form-item label="发证机关:"  prop="issueAuthority">
                <el-input  placeholder="" maxlength="17"  v-model="addFrom.issueAuthority" :readonly="read" :class="read?'disabled':''"></el-input>
              </el-form-item>
              <el-form-item label="车辆品牌:"  prop="brandModel">
                <el-input  placeholder="" maxlength="17"  v-model="addFrom.brandModel" :readonly="read" :class="read?'disabled':''"></el-input>
              </el-form-item>
              <el-form-item label="发证日期:" prop="issueDate">
                <el-date-picker
                  v-model="addFrom.issueDate"
                  format="yyyy-MM-dd"
                  value-format="timestamp"
                  type="date"
                    placeholder="选择日期时间"
                    :readonly="read" :class="read?'disabled':''"
                ></el-date-picker>
                </el-form-item>
              <el-form-item label="注册日期:" prop="registerDate">
                <el-date-picker
                  v-model="addFrom.registerDate"
                  format="yyyy-MM-dd"
                  value-format="timestamp"
                  type="date"
                    placeholder="选择日期时间"
                     :picker-options="pickerOptions"
                     :readonly="read" :class="read?'disabled':''"
                ></el-date-picker>
                </el-form-item>
                 <el-form-item label="长(米):" prop="vhcLongNameChang">
                <el-input  placeholder=""  maxlength="18" v-model="addFrom.vhcLongNameChang" :readonly="read" :class="read?'disabled':''"></el-input>
              </el-form-item>
               <el-form-item label="宽(米):" prop="vhcLongNamekuan">
                <el-input  placeholder=""  maxlength="18" v-model="addFrom.vhcLongNamekuan" :readonly="read" :class="read?'disabled':''"></el-input>
              </el-form-item>
               <el-form-item label="高(米):" prop="vhcLongNameGao">
                <el-input  placeholder=""  maxlength="18" v-model="addFrom.vhcLongNameGao" :readonly="read" :class="read?'disabled':''"></el-input>
              </el-form-item>
                <el-form-item label="道路运输经营许可证号:"  prop="businessLicenseNo" label-width="140">
                <el-input  placeholder=""  maxlength="17"  v-model="addFrom.businessLicenseNo" :readonly="read" :class="read?'disabled':''"></el-input>
              </el-form-item>
            <div class="addressBox">
              <h4 class="title">
                <span><i class="fa fa-picture-o iconFont" aria-hidden="true"></i>证件信息</span>
              </h4>
            </div>
            <div class="box" v-if="newImgFlag&&!read">
              <div class="imgBox">
                    <uploadImg :img='img' @remove ='handleRemove'  @change ='imgPreview'></uploadImg>
                    <h6 class="is-need">行驶证(正页)</h6>
                </div>
                <div class="imgBox">
                    <uploadImg :img='img1' @remove ='handleRemove1'  @change ='imgPreview1'></uploadImg>
                    <h6 class="is-need">行驶证(副页)</h6>
                </div>
                <div class="imgBox">
                    <uploadImg :img='img2'  @remove ='handleRemove2'  @change ='imgPreview2'></uploadImg>
                    <h6 class="is-need">道路运输证</h6>
                </div>
                <div class="imgBox">
                    <uploadImg :img='img3'  @remove ='handleRemove3'  @change ='imgPreview3'></uploadImg>
                    <h6 class="is-need">车头照片</h6>
                </div>
            </div>
             <div class="box" v-if="read">
              <div class="imgBox">
                    <el-image
                      style="width: 320px; height: 200px"
                      :src="addFrom.vhcLicense1Url"
                      :preview-src-list="[addFrom.vhcLicense1Url,addFrom.vhcLicense2Url,addFrom.transportPhotoUrl,addFrom.vhcPhoto1Url]">
                    </el-image>
                    <h6 class="is-need">行驶证(正页)</h6>
                </div>
                <div class="imgBox">
                    <el-image
                      style="width: 320px; height: 200px"
                      :src="addFrom.vhcLicense2Url"
                      :preview-src-list="[addFrom.vhcLicense2Url,addFrom.transportPhotoUrl,addFrom.vhcPhoto1Url,addFrom.vhcLicense1Url]">
                    </el-image>
                    <h6 class="is-need">行驶证(副页)</h6>
                </div>
                <div class="imgBox">
                   <el-image
                      style="width: 320px; height: 200px"
                      :src="addFrom.transportPhotoUrl"
                      :preview-src-list="[addFrom.transportPhotoUrl,addFrom.vhcPhoto1Url,addFrom.vhcLicense1Url,addFrom.vhcLicense2Url,]">
                    </el-image>
                    <h6 class="is-need">道路运输证</h6>
                </div>
                <div class="imgBox">
                    <el-image
                      style="width: 320px; height: 200px"
                      :src="addFrom.vhcPhoto1Url"
                      :preview-src-list="[addFrom.vhcPhoto1Url,addFrom.vhcLicense1Url,addFrom.vhcLicense2Url,addFrom.transportPhotoUrl]">
                    </el-image>
                    <h6 class="is-need">车头照片</h6>
                </div>
            </div>
          </div>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveFn('addFrom')">确 定</el-button>
      </span>
    </el-dialog>
 </div>
</template>

<script>
import { getCVehicleInfo, cVIupdate, cVIadd, cVLlist, cVTlist, cVPlist, cVElist, cVhcEnergyTypeList, cVhcNoColourList } from '@/api/vgs-driver2.0'
import { compressImage } from '@/utils/compressImage'
import uploadImg from '@/components/uploadImg.vue'
import { selectTenantListByName } from '@/api/soc-customer'
export default {
  name: 'addVehicle',
  components: {
    uploadImg
  },
  props: {
    rowData: {
      type: Object,
      default: function () {
        return {}
      }
    },
    isAdd: Boolean
    // isAdd: {
    //   type: Boolean,
    //   default: true

    // }
  },
  data () {
    return {
      read: false,
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now() - 8.64e7
        }
      },
      NYtype: [],
      cllx: [
        { value: '', label: '请选择' },
        { value: 1, label: '集港' },
        { value: 2, label: '外发' }
      ],
      clys: [],
      ssdw: [], // 所属单位列表
      importDialog: false,
      title: '添加',
      vehicleL: [],
      vehicleT: [],
      clyt: [],
      pfbz: [],
      vhcType: {},
      vhcL: {},
      ids: [],
      rules: {
        vhcLongNameChang: [
          { required: true, message: '请输入长', trigger: 'blur' }
        ],
        vhcLongNamekuan: [
          { required: true, message: '请输入宽', trigger: 'blur' }
        ],
        vhcLongNameGao: [
          { required: true, message: '请输入高', trigger: 'blur' }
        ],
        vhcNo: [
          { required: true, message: '请输入车牌号', trigger: 'blur' },
          this.rule.vhcNo
        ],
        noColour: [
          { required: true, message: '请选择车牌颜色', trigger: ['blur', 'change'] }
        ],
        vhcCompany: [
          { required: true, message: '请输入所属单位', trigger: 'blur' }
        ],
        vhcCompany1: [
          { required: true, message: '请输入所属个人', trigger: 'blur' }
        ],
        vhcType: [{ required: true, message: '请选择车辆类型', trigger: ['blur', 'change'] }],
        vhcClassify: [{ required: true, message: '请选择车辆所属', trigger: ['blur', 'change'] }],
        energy: [{ required: true, message: '请选择能源类型', trigger: ['blur', 'change'] }],
        purpose: [{ required: true, message: '请选择使用性质', trigger: ['blur', 'change'] }],
        standards: [{ required: true, message: '请选择排放标准', trigger: ['blur', 'change'] }],
        drivingLicense: [{ required: true, message: '请输入行驶证号', trigger: 'blur' }],
        vhcQuality: [{ required: true, message: '请输入总质量', trigger: 'blur' }],
        weight: [{ required: true, message: '请输入载重', trigger: 'blur' }],
        vhcVinNo: [{ required: true, message: '请输入车辆识别代号', trigger: 'blur' }],
        vhcEngineNo: [{ required: true, message: '请输入发动机号', trigger: 'blur' }],
        transportNo: [{ required: true, message: '请输入道路运输证号', trigger: 'blur' }],
        issueAuthority: [{ required: true, message: '请输入发证机关', trigger: 'blur' }],
        issueDate: [{ required: true, message: '请选择发证日期', trigger: ['blur', 'change'] }],
        registerDate: [{ required: true, message: '请选择注册日期', trigger: ['blur', 'change'] }],
        businessLicenseNo: [{ required: true, message: '请输道路运输经营许可证号', trigger: ['blur'] }],
        vehicleTenant: [{ required: true, message: '请选择所属单位/个人', trigger: ['blur'] }],
        vehicleTenantName: [{ required: true, message: '请所属单位/个人', trigger: ['blur'] }],
        brandModel: [{ required: true, message: '请输入车辆品牌', trigger: ['blur'] }]
      },
      dialogVisible: false,
      lookImgVisible: false,
      loading: 'false',
      vehicleSS: [
        {
          value: '',
          label: '请选择'
        },
        {
          value: 1,
          label: '单位'
        },
        {
          value: 2,
          label: '个人'
        }
      ],
      addFrom: {
        vhcClassify1: [],
        vhcPhoto1: '',
        vhcPhoto2: '',
        guaKaoUrl: ''
      },
      img: [],
      img1: [],
      img2: [],
      img3: [],
      imgList: [],
      newImgFlag: false,
      imgfile: new FormData()
    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    // this.tenantCode = localStorage.getItem('tenantCode')
    cVLlist({}).then(res => {
      this.vehicleL = res
      this.vehicleL.unshift({ id: '', name: '请选择' })
    })
    cVTlist({}).then(res => {
      this.vehicleT = res
      // this.vehicleT.unshift({ id: '', name: '请选择' })
    })
    cVPlist({}).then(res => {
      this.clyt = res
      this.clyt.unshift({ id: '', name: '请选择' })
    })
    cVElist({}).then(res => {
      this.pfbz = res
      this.pfbz.unshift({ id: '', name: '请选择' })
    })
    cVhcEnergyTypeList({}).then(res => {
      this.NYtype = res
      this.NYtype.unshift({ id: '', energyName: '请选择' })
    })
    cVhcNoColourList({}).then(res => {
      this.clys = res
      this.clys.unshift({ id: '', colourName: '请选择' })
    })
    if (this.isAdd) {
      this.addVeicle()
    } else {
      this.modifyVeicle(this.rowData)
    }
    // this.dialogVisible = true
    // this.newImgFlag = true
  },
  methods: {
    // 所属单位
    remoteMethod (query) {
      console.log(222)
      if (query !== '') {
        selectTenantListByName({ tenantNameLike: query }).then(res => {
          this.ssdw = res
        })
      }
    },
    // 所属切换
    classifyChange () {
      if (this.addFrom.vhcClassify == 2) {
        this.$set(this.addFrom, 'vehicleTenantName', '')
        this.$set(this.addFrom, 'vehicleTenantCode', '')
      }
    },
    // 图片上传
    handleRemove (data) {
      this.imgList[0] = null
    },
    imgPreview (data) {
      this.imgList[0] = data[0]
    },
    handleRemove1 (data) {
      this.imgList[1] = null
    },
    imgPreview1 (data) {
      this.imgList[1] = data[0]
    },
    handleRemove2 (data) {
      this.imgList[2] = null
    },
    imgPreview2 (data) {
      this.imgList[2] = data[0]
    },
    handleRemove3 (data) {
      this.imgList[3] = null
    },
    imgPreview3 (data) {
      this.imgList[3] = data[0]
    },
    // 获取车辆信息
    CPHfn () {
      if (this.isAdd) {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        this.newImgFlag = false
        getCVehicleInfo({ vhcNo: this.addFrom.vhcNo }).then(res => {
          loading.close()
          if (this.addFrom.id) { // 清空页面
            let vhcNo = this.addFrom.vhcNo
            this.addFrom = {
              vhcNo: vhcNo,
              vhcClassify1: []

            }
            this.vhcType = {}
            this.vhcL = {}
            this.img = []
            this.img1 = []
            this.img2 = []
            this.img3 = []
            this.newImgFlag = true
          } else {
            this.newImgFlag = true
          }
          if (res.id) {
            this.fuzhi(res)
            this.read = true
            this.newImgFlag = true
          }
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }
    },
    // 添加
    addVeicle () {
      this.title = '添加'
      this.dialogVisible = true
      this.isAdd = true
      this.newImgFlag = true
      if (this.$refs.addFrom) {
        this.$refs.addFrom.clearValidate()
      }
      this.read = false
    },
    // 车辆赋值
    fuzhi (row) {
      this.addFrom = JSON.parse(JSON.stringify(row))
      if (this.addFrom.vhcClassify == 1) {
        if (row.vehicleTenantCode == '') {
          this.$set(this.addFrom, 'vehicleTenant', row.vehicleTenantName)
        } else {
          this.ssdw = [{ tenantCode: row.vehicleTenantCode, tenantName: row.vehicleTenantName }]
          this.$set(this.addFrom, 'vehicleTenant', { tenantCode: row.vehicleTenantCode, tenantName: row.vehicleTenantName })
        }
      }
      if (row.vhcTypeId) {
        this.$set(this.addFrom, 'vhcType', { id: row.vhcTypeId, name: row.vhcTypeName })
      }
      if (row.noColourId) {
        this.$set(this.addFrom, 'noColour', { id: row.noColourId, name: row.noColourName })
      }
      if (row.energyId) {
        this.$set(this.addFrom, 'energy', { id: row.energyId, name: row.energyName })
      }
      if (row.purposeId == -1) {
        this.$set(this.addFrom, 'purpose', row.purposeName)
      } else {
        this.$set(this.addFrom, 'purpose', { id: row.purposeId, name: row.purposeName })
      }
      this.$set(this.addFrom, 'standards', { id: row.standardsId, name: row.standardsName })
      this.vhcL = { id: row.vhcLongId, name: row.vhcLongName }
      if (row.vhcLongName) {
        let long = this.addFrom.vhcLongName.split('*')
        // console.log(long);
        this.$set(this.addFrom, 'vhcLongNameChang', long[0])
        this.$set(this.addFrom, 'vhcLongNamekuan', long[1])
        this.$set(this.addFrom, 'vhcLongNameGao', long[2])
      }
      if (row.vhcLicense1Url) {
        this.$set(this.img, 0, { status: 'ready', url: row.vhcLicense1Url })
        this.$set(this.imgList, 0, 1)
      }
      if (row.vhcLicense2Url) {
        this.$set(this.img1, 0, { status: 'ready', url: row.vhcLicense2Url })
        this.$set(this.imgList, 1, 1)
      }
      if (row.transportPhotoUrl) {
        this.$set(this.img2, 0, { status: 'ready', url: row.transportPhotoUrl })
        this.$set(this.imgList, 2, 1)
      }
      if (row.vhcPhoto1Url) {
        this.$set(this.img3, 0, { status: 'ready', url: row.vhcPhoto1Url })
        this.$set(this.imgList, 3, 1)
      }
    },
    // 修改
    modifyVeicle (row) {
      this.addFrom = {
        vhcClassify1: [],
        vhcPhoto1: '',
        vhcPhoto2: '',
        guaKaoUrl: ''
      }
      this.vhcType = {}
      this.vhcL = {}
      if (this.$refs.table) {
        this.$refs.table.clearSelection()
      }
      this.img = []
      this.img1 = []
      this.img2 = []
      this.img3 = []
      this.img4 = []
      this.imgfile = null
      this.imgfile = new FormData()
      this.newImgFlag = false
      this.fuzhi(row)
      this.newImgFlag = true
      this.title = '修改'
      this.dialogVisible = true
      this.isAdd = false
      if (this.$refs.addFrom) {
        this.$refs.addFrom.clearValidate()
      }
      if (row.tenantId != localStorage.getItem('tenantCode')) {
        this.read = true
      } else {
        this.read = false
      }
    },
    saveFn (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // debugger
          if (this.addFrom.weight > 0 && this.addFrom.vhcQuality > this.addFrom.weight) {
            this.addFrom.vhcTypeName = this.addFrom.vhcType.name
            this.addFrom.vhcTypeId = this.addFrom.vhcType.id
            this.addFrom.vhcTypeCode = this.addFrom.vhcType.code

            this.addFrom.noColourName = this.addFrom.noColour.colourName
            this.addFrom.noColourId = this.addFrom.noColour.id
            this.addFrom.noColourCode = this.addFrom.noColour.colourCode

            this.addFrom.energyName = this.addFrom.energy.energyName
            this.addFrom.energyId = this.addFrom.energy.id
            this.addFrom.energyCode = this.addFrom.energy.energyCode

            if (this.addFrom.vhcClassify == 1) {
              if (typeof (this.addFrom.vehicleTenant) == 'string') {
                this.addFrom.vehicleTenantName = this.addFrom.vehicleTenant
                this.addFrom.vehicleTenantCode = ''
              } else {
                this.addFrom.vehicleTenantName = this.addFrom.vehicleTenant.tenantName
                this.addFrom.vehicleTenantCode = this.addFrom.vehicleTenant.tenantCode
              }
            }

            if (this.addFrom.purpose) {
              if (typeof (this.addFrom.purpose) == 'string') {
                this.addFrom.purposeName = this.addFrom.purpose
                this.addFrom.purposeId = -1
              } else {
                if (this.addFrom.purpose.id == '') {
                  this.addFrom.purposeName = null
                } else {
                  this.addFrom.purposeName = this.addFrom.purpose.name
                }
                this.addFrom.purposeId = this.addFrom.purpose.id
              }
            }
            if (this.addFrom.standards) {
              if (this.addFrom.standards.id == '') {
                this.addFrom.standardsName = null
              } else {
                this.addFrom.standardsName = this.addFrom.standards.name
              }
              this.addFrom.standardsId = this.addFrom.standards.id
            }

            this.addFrom.vhcLongName = this.addFrom.vhcLongNameChang + '*' + this.addFrom.vhcLongNamekuan + '*' + this.addFrom.vhcLongNameGao

            this.addFrom.vhcLongId = this.vhcL.id
            this.imgfile.set('params', JSON.stringify(this.addFrom))
            if (this.imgList.length == 4) {
              let arr = []
              for (let i = 0; i < this.imgList.length; i++) {
                if (this.imgList[i]) {
                  if (this.imgList[i] != 1) {
                    arr.push({ img: this.imgList[i], index: i })
                  }
                } else {
                  this.$alert('请上传证件信息', '系统提示')
                  return
                }
              }
              if (arr.length > 0) {
                for (let i = 0; i < arr.length; i++) {
                  let a = i
                  compressImage(arr[i].img.url, arr[i].img.raw, {
                    width: 1000
                  }).then(result => {
                    this.imgfile.append('file' + arr[a].index, result)// result即为压缩后的结果
                    if (a == arr.length - 1) {
                      this.save1()
                    }
                  })
                }
              } else {
                this.save1()
              }
            } else {
              this.$alert('请上传证件信息', '系统提示')
            }
          } else {
            this.$alert('总质量应该大于载重且载重不能为0', '系统提示')
          }
        } else {
          return false
        }
      })
    },
    save1 () {
      var that = this
      if (this.isAdd) {
        const loading = that.$loading({
          lock: true,
          text: '正在处理...'
        })
        cVIadd(that.imgfile).then(res => {
          loading.close()
          that.$message({
            message: '添加成功',
            type: 'success'
          })
          that.dialogVisible = false
          // that.getList(that.searchFrom)
          this.$parent.searchFn()
        }).catch(error => {
          that.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      } else {
        const loading = that.$loading({
          lock: true,
          text: '正在处理...'
        })
        cVIupdate(that.imgfile).then(res => {
          loading.close()
          that.$message({
            message: '修改成功',
            type: 'success'
          })
          that.dialogVisible = false
          // that.getList(that.searchFrom)
          this.$parent.searchFn()
        }).catch(error => {
          that.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }
    },
    closeDialog () {
      this.$emit('destroy')
      // this.$emit('update:dialogVisible', false)
    }
  },
  destroyed () {

  }
}
</script>

<style scoped lang='less'>
.searchBtnBox {
  margin-left: 10px;
}
.inpBox .el-date-editor{
      width: 350px!important;
}
.imgBox{
  display: flex;
  .item{
    display: flex;
     width: 50%;
     justify-content: space-around;
  }
}
.jiaoyan /deep/.el-date-editor {
    width: 150px!important;
}
/deep/.jiaoyan .el-date-editor .el-input__inner {
    width: 150px;
}
.box{
  display: flex;
  flex-wrap: wrap;
  .imgBox{
    display: flex;
      margin-right:30px;
    flex-direction: column;
    width: 320px;
    /deep/.el-upload--picture-card{
          width: 320px;
    height: 200px;
    }
  }
  h6{
    text-align: center;
  }
  .hidden /deep/.el-upload--picture-card{
  display: none;
  }
  /deep/.el-upload--picture-card {
    background-image: url(../../../assets/images/upload1.png);
    background-size: 320px;
  }
  /deep/.el-upload-list--picture-card .el-upload-list__item{
          width: 320px;
    height: 200px;
  }
}
.loogImgBox{
  display: flex;
  justify-content: space-around;
  .box1{
    width: 48%;
  }
  img{
    width: 100%;
  }
}

  /deep/.inpBox .bigInp .el-input__inner{
width: 250px;
}
.detailBox .el-form-item span{
  display:inline-block;
  width: 150px;
}
.detailBox img{
   width: 320px;
    height: 200px;
}
.detailBox /deep/ .el-date-editor--date .el-input__inner{
  border: none;
  font-size: 14px;

}
/deep/.image-slot{
    height: 100%;
    background: #f3f1f1;
    font-size: 38px;
    display: flex;
    align-items: center;
    justify-content: center;
}
/deep/.el-checkbox__input.is-disabled+span.el-checkbox__label {
    color: black;
    cursor: not-allowed;
}
.disabled /deep/.el-input__inner {
  background: #dcedff;
  color: black;
}
</style>
